import { z } from 'zod'

import { StringUtils } from '@/utils'

type TConfigValidadorEmailDuplicado = {
  documento?: string | null
  email?: string | null
  fieldPath: string[]
}

/**
 * Função utilitária para validar se um email já está associado a outro documento
 * @param configs - Objeto de configurações para validar múltiplos campos
 * @param emailsCadastrados - Array de registros de emails cadastrados
 * @param ctx - Contexto do Zod para adicionar issues
 */
export const validadorEmailDuplicado = (
  config: TConfigValidadorEmailDuplicado,
  emailsCadastrados: Record<string, string>,
  ctx: z.RefinementCtx,
) => {
  if (!config.documento) return z.NEVER
  if (!config.email) return z.NEVER
  const emailVinculado = emailsCadastrados[config.email]
  const isEmailJaAssociadoAOutroDocumento = emailVinculado !== StringUtils.normalize(config.documento)
  if (emailVinculado && isEmailJaAssociadoAOutroDocumento) {
    ctx.addIssue({
      message: 'Endereço de e-mail já vinculado a outro cpf na proposta',
      path: config.fieldPath,
      code: 'custom',
    })
  }
}
